module.exports = __webpack_public_path__ + "img/電気回路_4_8_2.e629b151.png";